import { HeightUnits } from '@utils/unit.utils';

import { DisplayModeEnum } from '@/types/authent/login.types';
import { MapFilters } from '@/types/filters.types';

import { Abstract, CoordinatesUnitEnum } from '../commons/commons.types';
import { ContextEnum } from './screenConfiguration.types';

export interface Setting {
  id: number;
  name: string;
  value: string;
}

export interface MapLayer extends Abstract {
  id: number;
  name: string;
  code: string;
  url?: string;
  type?: LayerTypeEnum;
}

export interface CameraGridConfigurationItem extends Abstract {
  streamId: number;
  row: number;
  col: number;
}

export interface UserSettings extends Abstract {
  id: number;
  userLogin?: string;
  language: string;
  displayMode: DisplayModeEnum;

  baseLayer: number;
  overlays: MapLayer['id'][];
  coordinatesUnit: CoordinatesUnitEnum;
  altitudeUnit: HeightUnits;
  heightUnit: HeightUnits;
  context: ContextEnum;

  axisInvertedY: boolean;
  linearJoystickCoefficient: number;
  zoomJoystickCameraSensitivity: number;
  automatedLad: boolean;
  speedVectorLength: number; // In seconds
  heightSuffix: boolean;

  mapFilters: MapFilters;
  groupCode?: string;
}

export enum TagOption {
  TARGET_IDENTIFICATION = 'target-identification',
  HEIGHT = 'height',
  DISTANCE = 'distance',
  GROUND_SPEED = 'ground-speed',
  VERTICAL_SPEED = 'vertical-speed',
  TENDENCY = 'tendency',
}

export enum SettingName {
  LANGUAGE = 'language',
  MAP_BACKGROUND = 'mapBackground',
  COORDINATES_UNIT = 'coordinatesUnit',
  MAP_FILTERS = 'mapFilters',
}

export enum LayerTypeEnum {
  BASE_LAYER = 'BASE_LAYER',
  MESH = 'MESH',
}
